const React = require('react');
const Sentry = require('@sentry/browser');
const { ErrorBoundary: SentryErrorBoundary } = require('@sentry/react');

exports.onClientEntry = (_, pluginOptions = {}) => {
  const { dsn, ...extraProps } = pluginOptions;

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    ...extraProps,
  });
};

exports.wrapRootElement = ({ element }, pluginOptions = {}) => {
  return pluginOptions.dsn ? React.createElement(SentryErrorBoundary, null, element) : element;
};
